<div class="min-h-screen  flex items-center justify-center p-4">
  <p-toast [position]="isMobile ? 'bottom-center' : 'top-right'" />

  <div class="w-full max-w-md">
    <p-card styleClass="shadow-2xl">
      <ng-template pTemplate="header">
        <div class="text-center py-6 bg-[oklch(87.2%_0.01_258.338)]  rounded-t-lg">
          <div class="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4">
            <i class="pi pi-lock text-2xl"></i>
          </div>
          <h1 class="text-2xl font-bold mb-2">Réinitialiser le mot de passe</h1>
          <p class="font-bold">Créez un nouveau mot de passe sécurisé</p>
        </div>
      </ng-template>

      <div class="p-6">
        <!-- Success State -->
        <div *ngIf="isSuccess" class="text-center space-y-6">
          <div class="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-4">
            <i class="pi pi-check-circle text-4xl text-green-500"></i>
          </div>
          <div>
            <h3 class="text-xl font-semibold text-gray-900 mb-2">Mot de passe réinitialisé !</h3>
            <p class="text-gray-600 mb-6">Votre mot de passe a été mis à jour avec succès.</p>
          </div>
          <p-button label="Se connecter" icon="pi pi-sign-in" (onClick)="goToLogin()"
            styleClass="w-full p-button-success" size="large">
          </p-button>
        </div>

        <!-- Reset Form -->
        <form *ngIf="!isSuccess" (ngSubmit)="onResetPassword()" class="space-y-6">

          <!-- New Password Field -->
          <div class="space-y-2">
            <label for="newPassword" class="block text-xl font-medium text-gray-700">
              Nouveau mot de passe
            </label>
            <div class="relative">
              <p-password [(ngModel)]="newPassword" name="newPassword" inputId="newPassword" size="large"
                placeholder="Entrez votre nouveau mot de passe" [toggleMask]="true" [feedback]="false"
                styleClass="w-full" inputStyleClass="w-full pl-4 pr-12 py-3" [weakLabel]="'Faible'"
                [mediumLabel]="'Moyen'" [strongLabel]="'Fort'" required>
              </p-password>

            </div>
            <small class="text-gray-500">Minimum 8 caractères avec lettres, chiffres et symboles</small>
          </div>

          <!-- Confirm Password Field -->
          <div class="space-y-2 ">
            <label for="confirmPassword" class="block text-xl font-medium text-gray-700">
              Confirmer le mot de passe
            </label>
            <div class="relative">
              <p-password [(ngModel)]="confirmPassword" name="confirmPassword" size="large" inputId="confirmPassword"
                placeholder="Confirmez votre mot de passe" [toggleMask]="true" [feedback]="false" styleClass="w-full"
                inputStyleClass="w-full pl-4 pr-12 py-3" required>
              </p-password>

            </div>
            <div *ngIf="confirmPassword && newPassword !== confirmPassword" class="flex items-center space-x-1">
              <i class="pi pi-times-circle text-red-500 text-sm"></i>
              <small class="text-red-500">Les mots de passe ne correspondent pas</small>
            </div>
            <div *ngIf="confirmPassword && newPassword === confirmPassword" class="flex items-center space-x-1">
              <i class="pi pi-check-circle text-green-500 text-sm"></i>
              <small class="text-green-500">Les mots de passe correspondent</small>
            </div>
          </div>


          <div>
            <p-button styleClass="w-full my-custom-btn" type="submit"
              [label]="isLoading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'"
              [icon]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'" [loading]="isLoading"
              [disabled]="!isFormValid()" styleClass="w-full" size="large"
              [severity]="isFormValid() ? 'primary' : 'secondary'">
            </p-button>
          </div>


          <div class="text-center pt-4">
            <p-button label="Retour à la connexion" icon="pi pi-arrow-left" (onClick)="goToLogin()"
              styleClass="p-button-text p-button-sm">
            </p-button>
          </div>
        </form>
      </div>
    </p-card>

    <!-- Footer -->
    <div class="text-center mt-6 text-sm text-gray-500">
      <p>Besoin d'aide ? <a href="mailto:support@analytix.com" class="text-indigo-600 hover:text-indigo-500">Contactez
          le support</a></p>
    </div>
  </div>
</div>